import styled from "@emotion/styled";

export const ListWrapper = styled.div`
  width: 100%;
`;